export default __webpack_public_path__ + "static/media/other-pet.2af0f02c.svg";